export default __webpack_public_path__ + "static/media/career_2.d3962c93.jpeg";